import * as React from "react";
import { StyleSheet, Image } from "react-native";
import { Paragraph, useTheme } from "react-native-paper";
import { Block } from "@block";
import { ValueQRCreator } from "../custom-qr-creator";
import QRCode from "react-native-qrcode-svg";
import { useTranslation } from "react-i18next";

interface QRViewCompactProps {
  value: ValueQRCreator;
  scale: number;
}

const QRViewCompact = (props: QRViewCompactProps) => {
  const { scale, value } = props;
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: {
          flex: 1,
        },
        titleHeader: { ...fonts.semibold, textAlign: "center", lineHeight: 16 / scale, fontSize: 24 / scale },
      }),
    [fonts.semibold, scale],
  );

  return (
    <Block bg={colors.whiteText} w={596 / scale}>
      <Block pt={24 / scale}>
        <Paragraph style={styles.titleHeader}>{value.accountName}</Paragraph>
      </Block>
      <Image
        style={{ width: 210 / scale, height: 81 / scale, alignSelf: "center" }}
        resizeMode={"center"}
        source={require("@assets/images/printqr/qrprint-3.png")}
      />
      <Block w100 h={269 / scale} center middle>
        <QRCode
          size={245 / scale}
          value={value.valueQR}
          logoBorderRadius={0}
          logoBackgroundColor={colors.backgroundForm}
          ecl="Q"
          quietZone={5}
        />
      </Block>
      <Block w100 center middle row>
        <Image
          style={{ width: 158 / scale, height: 95 / scale }}
          resizeMode={"center"}
          source={require("@assets/images/printqr/qrprint.png")}
        />
        <Block mh={16 / scale} bg="black" w={1} h={85 / scale} />
        <Image
          style={{ width: 158 / scale, height: 95 / scale }}
          resizeMode={"center"}
          source={require("@assets/images/printqr/qrprint-2.png")}
        />
      </Block>
      <Block center pt={42 / scale}>
        <Paragraph style={{ lineHeight: 16 / scale, fontSize: 20 / scale }}>
          {t("BENE_TEN_CHU_TAI_KHOAN")}: {value.accountName}
        </Paragraph>
      </Block>
      <Block center pt={37 / scale}>
        <Paragraph style={{ lineHeight: 16 / scale, fontSize: 20 / scale, ...fonts.semibold }}>
          {t("ACC_SO_TAI_KHOAN")}: {value.accountNumber}
        </Paragraph>
      </Block>
      <Block pb={23 / scale} center pt={37 / scale}>
        <Paragraph style={{ lineHeight: 16 / scale, fontSize: 20 / scale }}>{t("COMMON_NGAN_HANG_TMCP_DAI_CHUNG_VIET_NAM")}</Paragraph>
      </Block>
    </Block>
  );
};

export default QRViewCompact;
